// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.void-card {
  display: flex;
  margin-bottom: 42px;
  padding: 24px 20px 0px 16px;
}

.void-img {
  margin-right: 16px;
}

.card {
  flex-shrink: 0;
  border-radius: 12px;
  background: #fff;
  opacity: 1;
  padding: 0;
}

.card-header {
  display: flex;
  align-items: center;
  border-bottom: 0px !important;
  padding: 0;
}

.card-header-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
}

.card-header-content-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
}

.card-content.MuiDialogContent-root {
  padding: 0px;
}

.icon:hover {
  cursor: pointer;
}

.refund-info {
  display: flex;
  padding-top: 4px;
  padding-bottom: 24px;
}

.refund-info.MuiTypography-root {
  color: var(--text-high, rgba(1, 1, 2, 0.72));
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
}

.refund-transaction-details {
  display: flex;
  align-items: center;
  min-height: 80px;
  min-width: 420px;
}

.refund-capture-initiation {
  display: flex;
  margin-top: 26px;
  justify-content: space-between;
}

.input {
  display: flex;
  flex-direction: column;

  padding-bottom: 6px;
}
.input input {
  width: 192px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid var(--neutral-5, #d9d9d9);
  background: var(--neutral-1, #fff);
  padding: 7px 12px;
  gap: 4px;
}
.input input:focus {
  outline: none;
}

.country-code {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 38px;
  height: 32px;
  padding: 9px 12px;
  gap: 8px;
  border-radius: 0px 2px 2px 0px;
  border-top: 1px solid var(--neutral-5, #d9d9d9);
  border-right: 1px solid var(--neutral-5, #d9d9d9);
  border-bottom: 1px solid var(--neutral-5, #d9d9d9);
  background: var(--neutral-2, #fafafa);
}

.card-footer.MuiDialogActions-root {
  min-height: 72px;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 24px;
  box-shadow: 0px -2px 8px 0px rgba(39, 39, 39, 0.15);
}

.btn.MuiButton-root {
  display: inline-flex;
  height: 36px;
  padding: 6px 15px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: var(--generic-primary, #24b7aa);
  text-transform: none;
}

.cancel-btn.MuiButton-root {
  border-radius: 8px;
  border: 1px solid var(--neutral-5, #d9d9d9);
  background: var(--neutral-1, #fff);
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/orderManagement/OrderDetails/refundDialog.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,4CAA4C;EAC5C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;;EAEtB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;EAClC,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,QAAQ;EACR,8BAA8B;EAC9B,+CAA+C;EAC/C,iDAAiD;EACjD,kDAAkD;EAClD,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mDAAmD;AACrD;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,kCAAkC;EAClC,+CAA+C;AACjD","sourcesContent":[".void-card {\n  display: flex;\n  margin-bottom: 42px;\n  padding: 24px 20px 0px 16px;\n}\n\n.void-img {\n  margin-right: 16px;\n}\n\n.card {\n  flex-shrink: 0;\n  border-radius: 12px;\n  background: #fff;\n  opacity: 1;\n  padding: 0;\n}\n\n.card-header {\n  display: flex;\n  align-items: center;\n  border-bottom: 0px !important;\n  padding: 0;\n}\n\n.card-header-content {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 0;\n}\n\n.card-header-content-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 0;\n}\n\n.card-content.MuiDialogContent-root {\n  padding: 0px;\n}\n\n.icon:hover {\n  cursor: pointer;\n}\n\n.refund-info {\n  display: flex;\n  padding-top: 4px;\n  padding-bottom: 24px;\n}\n\n.refund-info.MuiTypography-root {\n  color: var(--text-high, rgba(1, 1, 2, 0.72));\n  font-family: Poppins;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n}\n\n.refund-transaction-details {\n  display: flex;\n  align-items: center;\n  min-height: 80px;\n  min-width: 420px;\n}\n\n.refund-capture-initiation {\n  display: flex;\n  margin-top: 26px;\n  justify-content: space-between;\n}\n\n.input {\n  display: flex;\n  flex-direction: column;\n\n  padding-bottom: 6px;\n}\n.input input {\n  width: 192px;\n  height: 32px;\n  border-radius: 2px;\n  border: 1px solid var(--neutral-5, #d9d9d9);\n  background: var(--neutral-1, #fff);\n  padding: 7px 12px;\n  gap: 4px;\n}\n.input input:focus {\n  outline: none;\n}\n\n.country-code {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 38px;\n  height: 32px;\n  padding: 9px 12px;\n  gap: 8px;\n  border-radius: 0px 2px 2px 0px;\n  border-top: 1px solid var(--neutral-5, #d9d9d9);\n  border-right: 1px solid var(--neutral-5, #d9d9d9);\n  border-bottom: 1px solid var(--neutral-5, #d9d9d9);\n  background: var(--neutral-2, #fafafa);\n}\n\n.card-footer.MuiDialogActions-root {\n  min-height: 72px;\n  display: flex;\n  align-items: center;\n  background: #fff;\n  padding: 24px;\n  box-shadow: 0px -2px 8px 0px rgba(39, 39, 39, 0.15);\n}\n\n.btn.MuiButton-root {\n  display: inline-flex;\n  height: 36px;\n  padding: 6px 15px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 8px;\n  background: var(--generic-primary, #24b7aa);\n  text-transform: none;\n}\n\n.cancel-btn.MuiButton-root {\n  border-radius: 8px;\n  border: 1px solid var(--neutral-5, #d9d9d9);\n  background: var(--neutral-1, #fff);\n  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
